import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, GraduationCap, Instagram } from "lucide-react";
import { BRAND, waLink, telLink } from "@/lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0B192C] text-white overflow-hidden">
      <div className="vk-grain" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 rounded-md bg-white/5 border border-white/10 grid place-items-center">
              <GraduationCap size={22} className="text-[#FF6B35]" />
            </span>
            <div>
              <div className="font-display text-xl font-bold">{BRAND.fullName}</div>
              <div className="text-xs text-white/50 tracking-widest uppercase">{BRAND.tagline}</div>
            </div>
          </div>
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            Patna&apos;s trusted CBSE &amp; ICSE coaching for Class VI to X — concept-first teaching, small batches,
            weekly tests, and mentoring that turns effort into results.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 grid place-items-center rounded-md text-white transition-transform hover:scale-105" style={{ background: "linear-gradient(45deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%)" }}>
              <Instagram size={18} />
            </a>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp" className="w-10 h-10 grid place-items-center rounded-md text-white transition-transform hover:scale-105" style={{ background: "#25D366" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.6-.8-1.9-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2.1-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.4-.3.3-1 .9-1 2.3s1 2.7 1.2 2.9c.1.2 2 3 4.8 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.6-.7 1.8-1.3.2-.6.2-1.1.2-1.3 0-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.4c1.4.7 3 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>
            </a>
          </div>
        </div>

        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Reach us</div>
          <ul className="space-y-3 text-white/70 text-sm">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-[#FF6B35]" />{BRAND.address}</li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[#FF6B35]" /><a href={telLink}>{BRAND.phonePrimary}</a></li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[#FF6B35]" />{BRAND.phoneSecondary}</li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-[#FF6B35]" /><a href={`mailto:${BRAND.email}`}>{BRAND.email}</a></li>
            <li className="flex gap-3"><Globe size={16} className="mt-0.5 text-[#FF6B35]" />{BRAND.domain}</li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Quick Links</div>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/courses" className="hover:text-white">Courses</Link></li>
            <li><Link to="/results" className="hover:text-white">Results</Link></li>
            <li><Link to="/study-materials" className="hover:text-white">Study Materials</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><a href={waLink()} target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp Us</a></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© 2026 {BRAND.fullName}. All Rights Reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white/80">Staff Login</Link>
        </div>
      </div>
    </footer>
  );
}
